export default "__VITE_ASSET__XaHPbda$__"